import { API_ENDPOINTS } from "../../enums/apiUrls";
import { logError } from "../../utils/customLogger";
import { getBearerToken } from "./bearerToken";

export interface AgentFieldDiff {
  field: string;
  agent_value?: string;
  user_value?: string;
}

export interface JCodeAgentDiffs {
  j_code: string;
  diffs: AgentFieldDiff[];
}

export interface GetAuthLetterAgentDiffRequest {
  order_id: string;
  auth_letter_path: string;
}

export interface GetAuthLetterAgentDiffResponse extends GetAuthLetterAgentDiffRequest {
  j_code_diffs?: JCodeAgentDiffs[];
}

export async function getAuthLetterAgentDiff(
  body: GetAuthLetterAgentDiffRequest,
): Promise<GetAuthLetterAgentDiffResponse | null> {
  const token = await getBearerToken();
  if (!token) {
    logError(new Error("getAuthLetterAgentDiff: no bearer token"));
    return null;
  }

  try {
    const response = await fetch(API_ENDPOINTS.GET_AUTH_LETTER_AGENT_DIFF, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(body),
    });

    if (!response.ok) {
      const text = await response.text();
      logError(
        new Error(
          `getAuthLetterAgentDiff failed: ${response.status} ${response.statusText}`,
        ),
        text,
      );
      return null;
    }

    return (await response.json()) as GetAuthLetterAgentDiffResponse;
  } catch (e) {
    logError(e instanceof Error ? e : new Error(String(e)));
    return null;
  }
}
